var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _rect4, _path19, _path20, _path21, _path22, _rect5, _rect6, _rect7, _rect8, _path23, _path24, _path25, _path26, _rect9, _rect10, _rect11, _rect12, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActividadInicioMvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c8a4e4;}.cls-2{fill:#e2d1f1;}.cls-3{fill:#434341;}.cls-4{fill:#ffb4e6;}.cls-5{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,94.87c-1.25,4.72-2.39,9.46-3.77,14.13-5,17-15.83,29.47-30.32,39.16-9.2,6.15-18.24,12.54-27.42,18.72a4.69,4.69,0,0,0-2.32,3.93c-.49,6.15-1.1,12.29-1.78,18.42a3.83,3.83,0,0,1-1.35,2.63c-4.78,2.74-9.68,5.29-14.85,8.06-.94-5.4-1.84-10.55-2.73-15.69-.49-2.83-1.55-3.75-4-2.45-5.25,2.78-9,.86-12.22-3.24q-3.85-4.9-7.39-10.06a4.58,4.58,0,0,1,0-5.81,15.74,15.74,0,0,0,1.51-2.57c1.08-2.17.44-3.77-1.84-4.65l-14.67-5.58c3.75-4.6,7.24-9,10.88-13.24a3.59,3.59,0,0,1,2.65-.65c6,.49,11.94,1,17.88,1.72a4.82,4.82,0,0,0,4.28-1.6c9.87-9.5,19.74-19,29.78-28.32,12-11.16,26.76-15.92,42.72-17.57,3.48-.36,7-.46,10.5-.69l4.88.47ZM165.57,112a10.22,10.22,0,0,0-11.3,9,10.4,10.4,0,0,0,9.27,11.4,10.24,10.24,0,0,0,11.1-9.24A10.05,10.05,0,0,0,165.57,112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.5,192.7c.82-2.75,1.54-5.53,2.48-8.24,2.58-7.46,6.59-13.88,13.69-18.06,1.55,1.38,1.2,2.5,0,4-5,6.36-6.88,13.81-7.49,22.05,8.14,1.09,15.82.5,23.14-3.07,2.06-1,2.05-1,4,.6-5.39,6.28-12.52,9-20.4,10.14-2.84.41-5.71.58-8.57.86l-7.59-.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326,158.44l30.1,122.69a2.17,2.17,0,0,0,2.65,1.59l27.75-6.94a2.18,2.18,0,0,0,1.58-2.64L372,207.43l-14-57a2.16,2.16,0,0,0-2.64-1.59l-16.18,4-11.57,2.89A2.18,2.18,0,0,0,326,158.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.24,284.4a3.77,3.77,0,0,1-3.67-2.89L324.46,158.82a3.81,3.81,0,0,1,2.76-4.58l27.76-7a3.79,3.79,0,0,1,4.6,2.78l30.1,122.69a3.81,3.81,0,0,1-2.76,4.58l-27.75,7A4.22,4.22,0,0,1,358.24,284.4ZM327.59,158.05l30.1,122.7a.56.56,0,0,0,.26.35.56.56,0,0,0,.43.06l27.75-6.94a.58.58,0,0,0,.42-.7l-30.1-122.69a.56.56,0,0,0-.26-.35.56.56,0,0,0-.43-.06L328,157.36a.58.58,0,0,0-.42.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292,158.44l30.1,122.69a2.17,2.17,0,0,0,2.65,1.59l27.75-6.94a2.18,2.18,0,0,0,1.58-2.64L324,150.45a2.16,2.16,0,0,0-2.64-1.59l-27.75,6.94A2.18,2.18,0,0,0,292,158.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M324.2,284.4a3.77,3.77,0,0,1-3.67-2.89L290.42,158.82a3.81,3.81,0,0,1,2.76-4.58l27.76-7a3.79,3.79,0,0,1,4.6,2.78l30.1,122.69a3.81,3.81,0,0,1-2.76,4.58l-27.75,7A4.22,4.22,0,0,1,324.2,284.4ZM293.55,158.05l30.1,122.7a.56.56,0,0,0,.26.35.56.56,0,0,0,.43.06l27.75-6.94a.58.58,0,0,0,.42-.7l-30.1-122.69a.56.56,0,0,0-.26-.35.55.55,0,0,0-.43-.06L294,157.36a.57.57,0,0,0-.42.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.06,248.84H155.83c-1.76,0-3.18.72-3.18,1.61v29.89c0,.89,1.42,1.61,3.18,1.61H286.06c1.76,0,3.18-.72,3.18-1.61V250.45C289.24,249.56,287.82,248.84,286.06,248.84Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.06,283.56H155.83c-2.78,0-4.79-1.35-4.79-3.22V250.45c0-1.86,2-3.22,4.79-3.22H286.06c2.78,0,4.79,1.36,4.79,3.22v29.89C290.85,282.21,288.84,283.56,286.06,283.56ZM154.26,280a3.35,3.35,0,0,0,1.57.32H286.06a3.44,3.44,0,0,0,1.58-.32V250.77a3.44,3.44,0,0,0-1.58-.32H155.83a3.35,3.35,0,0,0-1.57.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.06,215.86H155.83c-1.76,0-3.18.72-3.18,1.62v29.88c0,.89,1.42,1.62,3.18,1.62H286.06c1.76,0,3.18-.73,3.18-1.62V217.48C289.24,216.58,287.82,215.86,286.06,215.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.06,250.59H155.83c-2.78,0-4.79-1.36-4.79-3.23V217.48c0-1.87,2-3.23,4.79-3.23H286.06c2.78,0,4.79,1.36,4.79,3.23v29.88C290.85,249.23,288.84,250.59,286.06,250.59ZM154.26,247a3.32,3.32,0,0,0,1.57.33H286.06a3.41,3.41,0,0,0,1.58-.33V217.79a3.44,3.44,0,0,0-1.58-.32H155.83a3.35,3.35,0,0,0-1.57.32Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.06,182.88H155.83c-1.76,0-3.18.73-3.18,1.62v29.88c0,.89,1.42,1.62,3.18,1.62H286.06c1.76,0,3.18-.73,3.18-1.62V184.5C289.24,183.61,287.82,182.88,286.06,182.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.06,217.61H155.83c-2.78,0-4.79-1.36-4.79-3.23V184.5c0-1.87,2-3.23,4.79-3.23H286.06c2.78,0,4.79,1.36,4.79,3.23v29.88C290.85,216.25,288.84,217.61,286.06,217.61Zm-131.8-3.55a3.32,3.32,0,0,0,1.57.33H286.06a3.41,3.41,0,0,0,1.58-.33V184.81a3.58,3.58,0,0,0-1.58-.32H155.83a3.49,3.49,0,0,0-1.57.32Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.06,150.93H155.83c-1.76,0-3.18.73-3.18,1.62v29.88c0,.9,1.42,1.62,3.18,1.62H286.06c1.76,0,3.18-.72,3.18-1.62V152.55C289.24,151.66,287.82,150.93,286.06,150.93Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.06,185.66H155.83c-2.78,0-4.79-1.36-4.79-3.23V152.55c0-1.87,2-3.22,4.79-3.22H286.06c2.78,0,4.79,1.35,4.79,3.22v29.88C290.85,184.3,288.84,185.66,286.06,185.66Zm-131.8-3.54a3.35,3.35,0,0,0,1.57.32H286.06a3.44,3.44,0,0,0,1.58-.32V152.87a3.41,3.41,0,0,0-1.58-.33H155.83a3.32,3.32,0,0,0-1.57.33Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.25,272.06a1.1,1.1,0,0,1-.64-.2,1.08,1.08,0,0,1-.23-1.5l8.42-11.47a1.07,1.07,0,1,1,1.73,1.27l-8.42,11.47A1.07,1.07,0,0,1,106.25,272.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.11,294.06a1.09,1.09,0,0,1-.64-.21,1.07,1.07,0,0,1-.23-1.5l8.41-11.46a1.07,1.07,0,0,1,1.73,1.27L91,293.62A1.05,1.05,0,0,1,90.11,294.06Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.42,273.66a1.06,1.06,0,0,1-.63-.21L85.32,265a1.07,1.07,0,1,1,1.27-1.72l11.47,8.41a1.08,1.08,0,0,1,.23,1.5A1.1,1.1,0,0,1,97.42,273.66Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.42,289.8a1.09,1.09,0,0,1-.64-.21l-11.46-8.41a1.07,1.07,0,0,1,1.27-1.73l11.46,8.41a1.07,1.07,0,0,1,.23,1.5A1.05,1.05,0,0,1,119.42,289.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.91,
    y: 255.95,
    width: 2.15,
    height: 10.76,
    transform: "translate(-38.47 18.18) rotate(-8.72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.58,
    y: 286.34,
    width: 2.15,
    height: 10.76,
    transform: "translate(-43.03 19.24) rotate(-8.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.1,
    y: 277.7,
    width: 10.76,
    height: 2.15,
    transform: "translate(-41.32 16.52) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.48,
    y: 273.04,
    width: 10.76,
    height: 2.15,
    transform: "translate(-40.14 21) rotate(-8.71)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.21,57.3a1.08,1.08,0,0,1-1.07-1.06l-.37-24.58a1.08,1.08,0,0,1,1.06-1.09,1.1,1.1,0,0,1,1.09,1.06l.37,24.58a1.08,1.08,0,0,1-1.06,1.09Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.93,104.47a1.08,1.08,0,0,1-1.08-1.06l-.37-24.58a1.08,1.08,0,0,1,1.06-1.09,1.07,1.07,0,0,1,1.09,1.06l.37,24.58a1.07,1.07,0,0,1-1.06,1.09Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.13,69.08a1.08,1.08,0,0,1,0-2.15l24.58-.37a1.08,1.08,0,0,1,0,2.15l-24.59.37Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.3,68.37a1.08,1.08,0,0,1,0-2.15l24.58-.37A1,1,0,0,1,145,66.91,1.07,1.07,0,0,1,143.89,68l-24.58.37Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.43,
    y: 40.14,
    width: 2.15,
    height: 18.6,
    transform: "translate(-8.61 78.53) rotate(-45.86)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 125.57,
    y: 77.16,
    width: 2.15,
    height: 18.6,
    transform: "translate(-23.6 117.15) rotate(-45.86)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.16,
    y: 85.48,
    width: 18.6,
    height: 2.15,
    transform: "translate(-34.95 90.5) rotate(-45.87)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.18,
    y: 47.33,
    width: 18.6,
    height: 2.15,
    transform: "translate(3.67 105.48) rotate(-45.87)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353,88.54a1.08,1.08,0,0,1-.87-1.71l8.42-11.47a1.07,1.07,0,1,1,1.72,1.27L353.86,88.1A1.08,1.08,0,0,1,353,88.54Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.85,110.53a1.06,1.06,0,0,1-.63-.21,1.07,1.07,0,0,1-.23-1.5l8.41-11.46a1.07,1.07,0,1,1,1.73,1.27l-8.41,11.46A1.07,1.07,0,0,1,336.85,110.53Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.17,90.13a1.06,1.06,0,0,1-.63-.21L332.07,81.5a1.07,1.07,0,1,1,1.27-1.72l11.47,8.41a1.08,1.08,0,0,1,.23,1.5A1.1,1.1,0,0,1,344.17,90.13Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.16,106.27a1.06,1.06,0,0,1-.63-.21l-11.46-8.41a1.07,1.07,0,0,1,1.27-1.73l11.46,8.41a1.07,1.07,0,0,1-.64,1.94Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 345.66,
    y: 72.42,
    width: 2.15,
    height: 10.76,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -7.79, 53.48)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 350.33,
    y: 102.81,
    width: 2.15,
    height: 10.76,
    transform: "translate(-12.34 54.54) rotate(-8.72)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 328.84,
    y: 94.17,
    width: 10.76,
    height: 2.15,
    transform: "translate(-10.59 51.86) rotate(-8.74)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 359.23,
    y: 89.51,
    width: 10.76,
    height: 2.15,
    transform: "translate(-9.51 56.24) rotate(-8.71)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M487.13,123.15h6.21l14.35,15v-15H517v31.49h-6.52l-14.09-15v15h-9.22Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M522.81,123.15h9.5v18a5.68,5.68,0,0,0,1.37,4,4.66,4.66,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V142a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67a14.93,14.93,0,0,1-10.48-3.67,12.48,12.48,0,0,1-4-9.66Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M557.6,123.15h24.3v8H567.09v3.74h12.74v7.74H567.09v4h15.26v8H557.6Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M585.81,123.15h10.35l6.93,19.21,6.79-19.21h10.35l-12.91,31.49h-8.5Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M618.3,154.64l13-31.49h8.5l12.92,31.49H642.38l-1.53-4.36H630.23l-1.58,4.36ZM638,142.32l-2.43-6.89-2.47,6.89Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.79,208.64l13-31.49h8.51l12.91,31.49H456.86l-1.53-4.36H444.71l-1.57,4.36Zm19.71-12.32-2.43-6.89-2.48,6.89Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M490.07,190.42a7.2,7.2,0,0,0,.23-1.75,3,3,0,0,0-1.53-2.5,7.77,7.77,0,0,0-9.23,1.17,9,9,0,0,0,0,11.16,6.7,6.7,0,0,0,5.22,2.13,6,6,0,0,0,4.16-1.37,5.32,5.32,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-5,9.86,15.84,15.84,0,0,1-10.8,3.87,15.09,15.09,0,0,1-11.43-4.62,17.81,17.81,0,0,1,.2-23.69q4.62-4.63,12.08-4.63a16.36,16.36,0,0,1,10.4,3.21,10,10,0,0,1,4.09,8.22,6.49,6.49,0,0,1-.49,2.56Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M522.07,185.11v23.53h-9.49V185.11h-9.5v-8h28.48v8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M536,177.15h9.49v31.49H536Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M549.7,177.15h10.35L567,196.36l6.79-19.21h10.35l-12.91,31.49H562.7Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M588.35,177.15h9.5v31.49h-9.5Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M603.92,177.15h13.73a16.79,16.79,0,0,1,12,4.43,14.86,14.86,0,0,1,4.71,11.32,14.66,14.66,0,0,1-4.8,11.38,17,17,0,0,1-11.94,4.36H603.92Zm13.73,23.48a6.77,6.77,0,0,0,5.19-2.18,7.75,7.75,0,0,0,2-5.55,7.87,7.87,0,0,0-2-5.61,6.81,6.81,0,0,0-5.19-2.18h-4.23v15.52Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M635.24,208.64l13-31.49h8.5l12.92,31.49H659.32l-1.53-4.36H647.17l-1.58,4.36ZM655,196.32l-2.43-6.89-2.47,6.89Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M673.9,177.15h13.72a16.82,16.82,0,0,1,12,4.43,14.88,14.88,0,0,1,4.7,11.32,14.68,14.68,0,0,1-4.79,11.38,17.07,17.07,0,0,1-12,4.36H673.9Zm13.72,23.48a6.8,6.8,0,0,0,5.2-2.18,7.75,7.75,0,0,0,2-5.55,7.87,7.87,0,0,0-2-5.61,6.83,6.83,0,0,0-5.2-2.18h-4.23v15.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActividadInicioMvl);
export default __webpack_public_path__ + "static/media/Actividad_inicio-mvl.d04232cf43456194fd838370d09d9247.svg";
export { ForwardRef as ReactComponent };